export enum UserRoleEnum {
    Admin = "mteca:admin",
    User = "mteca:user",
    UserManager = "mteca:user-manager"
}
